import momment from "moment";

export const calculatePayment = (startDateTime, endDateTime, hourlyWage) => {
  if (!startDateTime || !endDateTime || !hourlyWage) return 0;
  const start = moment(startDateTime);
  const end = momment(endDateTime);

  const totalDuration = momment.duration(end.diff(start)).asHours();
  const totalWage = totalDuration * hourlyWage;
  return totalWage;
};
